// extracted by mini-css-extract-plugin
export var adCard = "_p9-8";
export var adCardBorder = "_p9-5";
export var arbiterButtonIcon = "_p9-p";
export var buttonIcon = "_p9-o";
export var container = "_p9-e";
export var copyButton = "_p9-m";
export var darkGrey = "_p9-u";
export var deliveryDate = "_p9-2";
export var divider = "_p9-n";
export var editModeWrapper = "_p9-7";
export var empty = "_p9-a";
export var errorIcon = "_p9-d";
export var filledCircle = "_p9-4";
export var fulfillmentFooter = "_p9-j";
export var grey = "_p9-s";
export var header = "_p9-i";
export var headerWrapper = "_p9-h";
export var highlighted = "_p9-6";
export var historyEntry = "_p9-3";
export var mobileColumn = "_p9-v";
export var mobileColumnReverse = "_p9-w";
export var orderDetailsContainer = "_p9-g";
export var orderMetadata = "_p9-l";
export var orderMetadataWrapper = "_p9-k";
export var packagesContainer = "_p9-b";
export var product = "_p9-y";
export var productImage = "_p9-z";
export var productInfo = "_p9-x";
export var productTitle = "_p9-10";
export var strikethrough = "_p9-t";
export var tinyText = "_p9-r";
export var title = "_p9-9";
export var trackerCard = "_p9-1";
export var trackerCardWrapper = "_p9-0";
export var trackingContainer = "_p9-f";
export var trackingTitle = "_p9-c";
export var xTinyText = "_p9-q";